export default __webpack_public_path__ + "static/media/SZ10.2169fb92.mp3";